import React, { Fragment, useEffect, useState } from 'react'

import {
  Button,
  CircularProgress,
  Collapse,
  Grid,
  IconButton,
  
  TextField,
  Typography
} from '@mui/material'
import { makeStyles } from '@mui/styles'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'

import { useApi } from '../../hooks/useApi'
import { ExternalAuditDetail } from './entities/ExternalAudit'
import { getExternalAudit, postSendMessageEntity } from './api'
import { eStatus, eTypeAction } from '../../enums/eExternalAudit'
import { Loading } from '../../components/UI'
import { Status } from '../../hooks/useFetchState'
import { fechaFormateada } from '../../utils/dateHelper'

interface ExternalAuditDetailProps {
  externalAuditId: string
  handleSnackbar: (message: string, success: boolean) => void
  handleCloseModal: () => void
}

export const ExternalAuditDetailModal: React.FC<ExternalAuditDetailProps> = ({
  externalAuditId,
  handleSnackbar,
  handleCloseModal
}) => {
  const classes = useStyles()
  const [open, setOpen] = useState<boolean>(false)
  const [openMsg, setOpenMsg] = useState<boolean>(false)
  const { state, callApi } = useApi<ExternalAuditDetail>()
  const { callApi: callApiMsg } = useApi<ExternalAuditDetail>()
  const [loading, setLoading] = useState<boolean>(false)

  const requestExternalAuditDetail = () => {
    setLoading(true)
    callApi(getExternalAudit(externalAuditId as string))
      .then(() => {
        setLoading(false)
      })
      .catch((error) => {
        handleSnackbar(error, false)
      })
    setLoading(false)
  }

  const requestExternalAuditMessage = () => {
    callApiMsg(postSendMessageEntity({ id: externalAuditId }))
      .then(() => {
        handleSnackbar('Entidad encolada correctamente', true)
        handleCloseModal()
      })
      .catch((error) => {
        handleSnackbar(error, false)
      })
  }

  useEffect(() => {
    requestExternalAuditDetail()
  }, [])

  if (state.status === Status.Loading) {
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )
  } else {
    return (
      <Fragment>
        <Grid
          container
          xs={12}
          sm={12}
          md={12}
          lg={12}
          spacing={1}
          style={{ paddingLeft: '40px' }}
        ></Grid>
        <hr />
        <Typography variant='subtitle1' style={{ fontWeight: 'bold' }}>
          Resumen
        </Typography>

        <Grid
          container
          xs={12}
          sm={12}
          md={12}
          lg={12}
          spacing={1}
          style={{ paddingLeft: '40px', paddingTop: '10px' }}
        >
          <Grid item xs={12} md={6}>
            <Typography variant='body2' component='p'>
              <b>Externo:</b>
              {` ${state.data?.externalName}`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant='body2' component='p'>
              <b>Marca:</b>
              {` ${state.data?.brand}`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant='body2' component='p'>
              <b>Id Referencia:</b>
              {` ${state.data?.referenceId || 'N/A'}`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant='body2' component='p'>
              <b>Fecha Gestión:</b>
              {` ${
                fechaFormateada(
                  state.data?.requestDate,
                  'dd/MM/yyyy hh:mm a'
                ) || 'Sin Fecha'
              }`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant='body2' component='p'>
              <b>Estado:</b>
              {state.data?.statusId && ` ${eStatus[state.data?.statusId]}`}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant='body2' component='p'>
              <b>Tipo Proceso:</b>
              {state.data?.typeProcessId &&
                ` ${eTypeAction[state.data?.typeProcessId]}`}
            </Typography>
          </Grid>
        </Grid>
        <hr />
        {loading && <Loading />}
        <div className={classes.accordeonSummary}>
          <Typography variant='subtitle1' style={{ fontWeight: 'bold' }}>
            Detalle Llamada
          </Typography>
          <IconButton onClick={() => setOpen(!open)}>
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </div>
        <Collapse in={open} timeout='auto' unmountOnExit>
          <Grid
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            spacing={1}
            style={{ paddingLeft: '40px', paddingTop: '10px' }}
          >
            <Grid item xs={12} md={8}>
              <Typography variant='body2' component='p'>
                <b>Url:</b>
                {` ${state.data?.requestUrl}`}
              </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
              <b>Data/Body:</b>
              <TextField
                disabled={true}
                minRows={4}
                maxRows={4}
                variant='outlined'
                multiline
                fullWidth
                value={state.data?.requestData}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <b>Respuesta:</b>
              <TextField
                disabled={true}
                minRows={4}
                maxRows={4}
                variant='outlined'
                multiline
                fullWidth
                value={state.data?.requestResponse}
              />
            </Grid>
          </Grid>
        </Collapse>

        <hr />
        <div className={classes.accordeonSummary}>
          <Typography variant='subtitle1' style={{ fontWeight: 'bold' }}>
            {' '}
            Detalle Mensaje Origen
          </Typography>
          <IconButton onClick={() => setOpenMsg(!openMsg)}>
            {openMsg ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </div>
        <Collapse in={openMsg} timeout='auto' unmountOnExit>
          <Grid
            container
            xs={12}
            sm={12}
            md={12}
            lg={12}
            spacing={1}
            style={{ paddingLeft: '40px', paddingTop: '10px' }}
          >
            <Grid item xs={12} md={8}>
              <Typography variant='body2' component='p'>
                <b>Nombre Mensaje:</b>
                {` ${state.data?.messageName}`}
              </Typography>
            </Grid>
            <Grid item xs={12} md={12}>
              <b>Mensaje:</b>
              <TextField
                disabled={true}
                minRows={4}
                maxRows={4}
                variant='outlined'
                multiline
                fullWidth
                value={state.data?.messageData}
              />
            </Grid>
          </Grid>
        </Collapse>
        <hr />
        {state.data?.isExternalRequest ||
          state.data?.statusId === eStatus.Satisfactorio ||
          state.data?.statusId === eStatus.Ejecutado || (
            <Grid item xs={12} md={12} style={{ textAlign: 'center' }}>
              <Button
                disabled={false}
                variant='contained'
                color='primary'
                style={{ width: 'auto', padding: '6px 12px', fontSize: '14px' }}
                onClick={requestExternalAuditMessage}
                fullWidth
                endIcon={<CircularProgress size={10} />}
              >
                Reenviar
              </Button>
            </Grid>
          )}
      </Fragment>
    )
  }
}

const useStyles = makeStyles(() => ({
  accordeonSummary: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, .03)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56
    },
    justifyContent: 'space-between',
    paddingLeft: '16px',
    border: '1px solid rgba(0, 0, 0, .125)',
    borderRadius: '4px',
    borderBottom: '2px solid rgba(0, 0, 0, .125)'
  }
}))
